function SessionContext() {
	this.session = { isGuestSignedIn: false };
}

SessionContext.prototype.isGuestLoggedIn = function (shopperId) {

    this.session.isGuestSignedIn = shopperId !== 0 && shopperId !== '' ? true : false;

	return this.session.isGuestSignedIn;
};

SessionContext.prototype.signGuestIn = function () {
	this.session.isGuestSignedIn = true;
};

SessionContext.prototype.signGuestOut = function () {
	this.session.isGuestSignedIn = false;
};

module.exports = SessionContext;


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/login/session-context.js
 **/